import React from "react";

import { Typography, Switch } from "clearsense-ui/components";

import { getIcon } from "../utils";

const ConnectionDetails = ({ connection, status, setStatus }) => (
  <>
    <Typography style="h4" className="border-b-2">
      Connection Details
    </Typography>
    <div className="flex ">
      <Typography style="h5" className="w-2/5">
        Source
      </Typography>
      <Typography style="h5" className="w-2/5">
        Target
      </Typography>
      <Typography style="h5" className="w-1/5">
        Enabled
      </Typography>
    </div>
    <div className="flex">
      <div className="flex w-2/5 space-x-2">
        {getIcon(connection?.sourceIcon)}
        <Typography style="h5">{connection?.destinationName}</Typography>
      </div>
      <div className="flex w-2/5 space-x-2">
        {getIcon(connection?.destinationIcon)}
        <Typography style="h5">{connection?.destinationName}</Typography>
      </div>
      <Switch
        checked={status}
        onChange={() => setStatus(prev => !prev)}
        data-cy="connection-status-switch"
      ></Switch>
    </div>
  </>
);

export default ConnectionDetails;
